import { render, staticRenderFns } from "./social-trading.vue?vue&type=template&id=010ea7ea"
import script from "./social-trading.vue?vue&type=script&lang=js"
export * from "./social-trading.vue?vue&type=script&lang=js"
import style0 from "./social-trading.vue?vue&type=style&index=0&id=010ea7ea&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports